import { motion } from 'framer-motion';
import './ARVRSection.css';

const ARVRSection = () => {
    return (
        <section className="arvr-section">
            <div className="arvr-container">
                <motion.div
                    className="arvr-content"
                    initial={{ opacity: 0, y: 30 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.8 }}
                >
                    <h2 className="arvr-title">Architect's futuristic vision</h2>
                    <h3 className="arvr-subtitle">VR & AR uses in Architecture and Design</h3>
                    <p className="arvr-description">
                        The emergence of virtual reality applications for architecture has been one of the big stories of the past few years.
                        In the future, VR will become an integral part of presenting a project and the design process.
                    </p>
                    <p className="arvr-description">
                        The biggest challenge is often convincing the client that the end product will look just like-or better than-the 2D or 3D presentation.
                    </p>
                    <p className="arvr-description">
                        We are here as a team to represent our designs in a best possible manner. VR technology has so much potential for design mock-ups,
                        to project collaboration, through to the finishing touches that make a building design go from good to great.
                    </p>
                </motion.div>

                <motion.div
                    className="arvr-image-wrapper"
                    initial={{ opacity: 0, scale: 0.9 }}
                    whileInView={{ opacity: 1, scale: 1 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.8, delay: 0.2 }}
                >
                    <img
                        src="/images_final/5_ar_n_vr/IMAGE_F.jpg"
                        alt="VR Architecture Experience"
                        className="arvr-image"
                    />
                </motion.div>
            </div>
        </section>
    );
};

export default ARVRSection;
